import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Box, Typography } from "@mui/material";

const slides = [
  
  {
    title: "Your Partner in Digital Transformation",
    subtitle:
      "At Europa Solutions, a global website development company, mobile app development company, and digital marketing agency, we deliver innovative, results-driven solutions that help businesses grow and succeed.",
    page1: "Learn More",
    page2: "About Us",
    button: " Our Work ➝",
    link: "/about",
    badges: ["Creativity", "Cutting-Edge Technology", "Innovation"],
  },
  {
    title: "Our Commitment to Excellence",
    subtitle:
      "We're more than just a service provider – we are your trusted digital marketing agency and technology partner. At Europa Solutions, we stand for:",
    page1: "Long-Term",
    page2: "Partnerships",
    button: " Lets Talk ➝",
    link: "/contact",
    badges: ["Client Focuses", "Innovation", "Integrity & Collabaration"],
  },
  {
    title: "Driving Growth for Businesses Like Yours.",
    subtitle:
      "Whether you’re a startup or a global enterprise, we empower you with custom web development solutions, mobile app development services, and digital marketing strategies that deliver results.",
    page1: "Get a Free",
    page2: "Consultation",
    button: " Contact Us ➝",
    link: "/contact",
    badges: [
      "Stragetic Marketing Plans",
      "Custom Web Solutions",
      "Ongoing support & Partnership",
    ],
  }
];

const Hero6 = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        backgroundImage: `url(/img/home/background-1-min.gif)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#fff",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        px: { xs: 2, md: 8 },
      }}
    >
      <Box sx={{ textAlign: "left", maxWidth: { xs: "90%", md: 600 } }}>
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{ fontSize: { xs: "1.8rem", md: "2.5rem" }, color: "#fff" }}
        >
          {slides[currentSlide].title}
        </Typography>
        <Typography
          variant="h6"
          sx={{ mt: 2, fontSize: { xs: "1rem", md: "1.2rem" }, color: "#fff" }}
        >
          {slides[currentSlide].subtitle}
        </Typography>

        <Box sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: { xs: 1},
        }}
        >
          {slides[currentSlide].badges.map((badge, index) => (
            <Box key={index} sx={{
              width: { xs: "100%", md: "auto" },
            }}>
              <Typography
                variant="body2"
                sx={{
                  mt: 1,
                  fontSize: { xs: "0.8rem", md: "1rem" },
                  display: "inline-block",
                  px: 1,
                  py: 0.3,
                  mr: 1,
                  backdropFilter: "blur(8px)",
                  backgroundColor: "rgba(255, 255, 255, 0.3)",
                  color: "#fff",
                  borderRadius: "5px",
                }}
                className="badge"
              >
                {badge}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* CTA Button */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "transparent",
            borderRadius: "50px",
            // px: { xs: 2, md: 4 },
            py: { xs: 1, md: 1.5 },
            maxWidth: "fit-content",
            flexWrap: "wrap",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: "#fff",
              fontSize: { xs: "0.9rem", md: "1rem" },
              fontWeight: "500",
              pr: 2,
            }}
          >
            {slides[currentSlide].page1} <br /> {slides[currentSlide].page2}
          </Typography>

          <Box
            sx={{
              height: "30px",
              width: "2px",
              backgroundColor: "#fff",
              mx: 1,
            }}
          />

          <Button
            variant="contained"
            sx={{
              backgroundColor: "#C42776",
              color: "#fff",
              borderRadius: "50px",
              textTransform: "none",
              fontWeight: "bold",
              px: { xs: 2, md: 3 },
              fontSize: { xs: "0.8rem", md: "1rem" },
              "&:hover": {
                backgroundColor: "#E8B7EB",
                color: "#C42776",
              },
            }}
            component={Link}
            to={slides[currentSlide].link}
          >
            {slides[currentSlide].button}
          </Button>
        </Box>

        {/* Carousel Indicators */}
        <Box sx={{ mt: 1, display: "flex", gap: 1 }}>
          {slides.map((_, index) => (
            <Box
              key={index}
              sx={{
                width: 15,
                height: 15,
                bgcolor: currentSlide === index ? "#C42776" : "#C9C9C9",
                borderRadius: "50%",
                border: "3px solid #FBFBFB",
              }}
            />
          ))}
        </Box>
      </Box>

      {/* Scrolling Marquee */}
      {/* <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: "60%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          mb: 5,
        }}
      >
        <Typography
          sx={{ fontSize: "1.3rem", fontWeight: "bold", color: "#fff" }}
        >
          Stack We Follow:
        </Typography>
        <Typography
          component="marquee"
          loop="infinite"
          sx={{ fontSize: "1.8rem", fontWeight: "bold", color: "#fff" }}
        >
          ✳ Bookify &nbsp;&nbsp;&nbsp; ✳ Bookify &nbsp;&nbsp;&nbsp; ✳ Bookify
          &nbsp;&nbsp;&nbsp; ✳ Bookify &nbsp;&nbsp;&nbsp; ✳ Bookify
          &nbsp;&nbsp;&nbsp; ✳ Bookify &nbsp;&nbsp;&nbsp; ✳ Bookify
        </Typography>
      </Box> */}
    </Box>
  );
};

export default Hero6;
